import { inject, Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';

import { CsvAsStringArrays } from '@malou-io/package-utils';

import { SemanticAnalysisReviewForCsv } from '#modules/statistics-e-reputation/models/semantic-analysis.interface';
import { AbstractCsvService } from '#modules/statistics/components/download-insights-modal/models/csv-service.abstract';
import { StatisticsStore } from '#modules/statistics/stores/store/statistics.store';

type Data = SemanticAnalysisReviewForCsv[] | undefined;

@Injectable()
export class SemanticAnalysisDetailsCsvInsightsService extends AbstractCsvService<Data> {
    private readonly _statisticsStore = inject(StatisticsStore);

    protected _getData$(): Observable<Data> {
        return of(this._statisticsStore.semanticAnalysisDetailsData());
    }

    protected override _isDataValid(data: Data): boolean {
        return !!data;
    }

    protected override _getCsvHeaderRow(): string[] {
        return ['Date Start', 'Date End', 'Category', 'Topic', 'Sentiment', 'Review Rating', 'Review', 'Review ID'];
    }

    protected override _getCsvDataRows(data: Exclude<Data, undefined>): CsvAsStringArrays {
        return data.map((topic) => [
            topic.startDate,
            topic.endDate,
            topic.category,
            topic.name,
            topic.sentiment,
            topic.reviewRating?.toString() ?? '',
            topic.review,
            topic.reviewId,
        ]);
    }
}
